import gsap from "gsap";

export class Guides {
  constructor() {
    this.guides = null;
    this.toggleGuides = null;

    this.init();
  }

  /**
   * 📐 Initialize the guides component
   * @returns {void}
   */
  init() {
    this.createGuides();
    this.setupAnimation();
    this.checkPreviousState();
    this.setupEventListeners();
  }

  /**
   * 🏗️ Create the guides element
   * @private
   */
  createGuides() {
    this.guides = document.createElement("div");
    this.guides.className = "guides wrap";
    this.guides.innerHTML = `
      <div class="inner grid">
        ${Array(12).fill('<div class="guides__guide"></div>').join("")}
      </div>
    `;
    document.body.appendChild(this.guides);
  }

  /**
   * 🎭 Set up the animation for guides
   * @private
   */
  setupAnimation() {
    this.toggleGuides = gsap
      .to(this.guides, {
        duration: 0.25,
        ease: "power2.inOut",
        autoAlpha: 1,
        paused: true,
      })
      .reverse();
  }

  /**
   * 🔍 Check if guides were previously enabled
   * @private
   */
  checkPreviousState() {
    if (localStorage.getItem("debug") === "true") {
      this.toggleGuides.play().progress(1);
    }
  }

  /**
   * ⌨️ Set up event listeners
   * @private
   */
  setupEventListeners() {
    document.addEventListener("keydown", this.handleKeyPress.bind(this));
    window.addEventListener("resize", this.updateWindowWidth.bind(this));
    this.updateWindowWidth();
  }

  /**
   * 🔄 Handle key press for toggling guides
   * @private
   * @param {KeyboardEvent} e - The keyboard event
   */
  handleKeyPress(e) {
    if (e.key === "g" && e.ctrlKey) {
      this.toggleGuides.reversed()
        ? this.toggleGuides.play()
        : this.toggleGuides.reverse();
      localStorage.setItem("debug", !this.toggleGuides.reversed());
    }
  }

  /**
   * 📏 Update window width in guides dataset
   * @private
   */
  updateWindowWidth() {
    this.guides.dataset.windowWidth = window.innerWidth;
  }
}
